'use client';

import React from 'react';
import Button from '@/components/common/Button';
import { faStar as faStarFilled } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faStarEmpty } from '@fortawesome/pro-regular-svg-icons';

interface FavoriteButtonProps {
  isFavorite: boolean;
  disabled?: boolean;
  onFavoriteToggle: () => void;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ isFavorite, disabled, onFavoriteToggle }) => {
  return (
    <Button
      variant={isFavorite ? 'secondary' : 'primary'}
      icon={isFavorite ? faStarFilled : faStarEmpty}
      buttonClassName="border-none w-10 h-7 btn-xs"
      disabled={disabled}
      onClick={() => onFavoriteToggle()}
    />
  );
};

export default FavoriteButton;
